export const I18n = {
	'en': {
		messagesList_title: 'Messages history',
		message_title: 'Message',
		time: 'Time',
		packageName: 'Package Name',
		apk: 'APK',
		notificationsList_title: 'Updates',
		note_title: 'Action',
		statusAccepted: 'Accepted',
		statusDeclined: 'Declined',
		statusUpdated: 'Updated',
		statusOutdated: 'Outdated',
		statusNew: 'Новый',
		accept: 'Accept',
		decline: 'Cancel',
		noStatus: 'none',
		status: 'Status',
		cancel: 'Cancel',
		update: 'Update All',
		changes: 'Changes',
		changedBy: 'Changed by',
		app: 'App',
		version: 'Version'
	},
	'ru': {
		messagesList_title: 'История уведомлений',
		message_title: 'Сообщение',
		time: 'Время',
		packageName: 'Имя пакета',
		apk: 'АПК',
		notificationsList_title: 'Обновления',
		note_title: 'Обновление',
		statusAccepted: 'Одобрен',
		statusDeclined: 'Отменен',
		statusUpdated: 'Обновлен',
		statusOutdated: 'Устарел',
		statusNew: 'Новый',
		accept: 'Принять',
		decline: 'Отменить',
		noStatus: 'none',
		status: 'Статус',
		cancel: 'Отменить',
		update: 'Обновить все',
		changes: 'Изменения',
		changedBy: 'Изменено',
		app: 'Приложение',
		version: 'Версия'
	},
	'sk': {
		messagesList_title: 'História upozornení',
		message_title: 'Správa',
		time: 'čas',
		packageName: 'Názov balíka',
		apk: 'APK',
		notificationsList_title: 'Aktualizácie',
		note_title: 'Aktualizovať',
		statusAccepted: 'Schválený',
		statusDeclined: 'Zrušený',
		statusUpdated: 'Aktualizované',
		statusOutdated: 'Zastaraný',
		statusNew: 'Nový',
		accept: 'Prijať',
		decline: 'Zrušiť',
		noStatus: 'none',
		status: 'Postavenie',
		cancel: 'Zrušiť',
		update: 'Obnoviť všetko',
		changes: 'Zmeny',
		changedBy: 'Zmenený',
		app: 'App',
		version: 'Verzia'
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/alerts/index.js